<template>
  <div>
    <div class="canlender-basic">
      <div class="title">当前频道：</div>
      <div class="name">{{name}}</div>
      <span class="currentNumber"><i>{{channelIds.length === 0 ? 0 : index + 1}}</i>/<i>{{channelIds.length}}</i></span>
    </div>
    <div class="canlender-cont">
      <swiper class="swiper-container" :options="swiperOption">
        <swiper-slide v-for="item in channelsB" :key="item.channel_id">
           <mmc-default v-if="item.channel_id === 1" :canlenderInfo="canlenderInfoB" :weatherInfo="weatherInfoB"></mmc-default>
           <hei-xia-zi v-else :canlenderInfo="canlenderInfoB" :imgUrl="item.channel_image_url" :codeUrl="item.qrcode_image"></hei-xia-zi>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
import MmcDefault from '../StyleCommponent/MmcDefault/MmcDefault.vue'
import HxzDefault from '../StyleCommponent/HxzDefault/HxzDefault.vue'
import WeiYi from '../StyleCommponent/WeiYi/WeiYi.vue'
import DanXiang from '../StyleCommponent/DanXiang/DanXiang.vue'
import HeiXiaZi from '../StyleCommponent/HeiXiaZi/HeiXiaZi.vue'
var _this = null
export default {
  name: 'MmcCanlender',
  components: {
    MmcDefault,
    HxzDefault,
    WeiYi,
    DanXiang,
    HeiXiaZi
  },
  props: {
    ChannelId: Number,
    canlenderInfo: Object,
    weatherInfo: Object,
    channels: Array
  },
  data () {
    return {
      canlenderInfoB: this.canlenderInfo,
      weatherInfoB: this.weatherInfo,
      channelsB: this.channels,
      channel_id: this.canlenderInfo.channel_id,
      channelIds: [],
      index: 0,
      name: '',
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 14,
        on: {
          slideChangeTransitionEnd: function () {
            _this.index = this.activeIndex
            _this.name = _this.channelsB[this.activeIndex].channel_name
          }
        }
      }
    }
  },
  methods: {
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    }
  },
  watch: {
    canlenderInfo (newValue) {
      if (!newValue) return
      this.canlenderInfoB = newValue
      this.channel_id = newValue.channel_id
    },
    weatherInfo (newValue) {
      if (!newValue) return
      this.weatherInfoB = newValue
    },
    channels (newValue) {
      if (!newValue) return
      this.channelsB = newValue
      var len = this.channelsB.length
      if (this.index > (len - 1)) {
        this.index = 0
      }
      this.name = newValue[this.index].channel_name
      this.channelIds.splice(0, this.channelIds.length)
      if (len > 0) {
        for (var i = 0; i < len; i++) {
          var id = this.channelsB[i].channel_id
          this.channelIds.push(id)
        }
      }
    }
  },
  created () {
    _this = this
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.canlender-basic
  height 44px
  padding 10px 20px 0
  font-size 12px
  color #000000
  position relative
  .name
    padding-top 6px
    color #999999
  .currentNumber
    position absolute
    right 20px
    bottom 16px
.canlender-cont
  width 100vw
  height 400px
  background #ffffff
  overflow hidden
  .swiper-container
    width 100%
    height 100%
    .swiper-slide
      width: 300px
      height 400px
      overflow hidden
      .imgurl
        backgroundImg()
@media (min-width: 1024px)
  .canlender-cont
    heigth 300px
    .swiper-container
      .swiper-slide
        width: 255px
        height 300px
</style>


// WEBPACK FOOTER //
// src/canlender/mmc/mmc.vue